import axios from "../utils/axios";

export class ClinicService {
  getAllClinics() {
    return axios.get("/clinics");
  }
  createClinic(data: any) {
    return axios.post("/clinics", data);
  }
  updateClinic(id: string, data: any) {
    return axios.put(`/clinics/${id}`, data);
  }
  deleteClinic(id: string) {
    return axios.delete(`/clinics/${id}`);
  }
}
